import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import includes from 'lodash/includes';

import { setDisplayName } from '../../../../shared/react-hocs/hoc-helpers';

function withCheckPermission(WrappedComponent) {
	function WithCheckPermission(props) {
		return (
			<WrappedComponent {...props} />
		);
	}

	function mapStateToProps(state) {
		return {
			check: permission => includes(state.root.data.permissions, permission)
		};
	}

	function mergeProps(stateProps, dispatchProps, ownProps) {
		return {
			...ownProps,
			...stateProps
		};
	}

	setDisplayName(WithCheckPermission, WrappedComponent);

	return connect(mapStateToProps, null, mergeProps)(WithCheckPermission);
}

export const CheckPropType = PropTypes.func.isRequired;

export default withCheckPermission;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/check-permission-hoc.js